import {observable, action} from 'mobx';
import _ from 'lodash';

class ResourcesStore {

  @observable resources = [];
  @observable resource = _.assign({}, {
    title: '',
    file: {},
    resourse_type: '',
  });
  @observable errors = {};

  @action
  setResources = resources => {
    this.resources = resources;
  };

  @action
  initNewResource = () => {
   this.resource = _.assign({}, {
    title: '',
    file: {},
    resourse_type: '',
  });
  };

  @action
  setError = errors => {
    this.errors = errors;
  };

  @action
  setResource = resource => {
    this.resource = resource;
  };

  @action
  updateResource = resource => {
    const allResources = [...this.resources];
    let oldResourceIndex = allResources.findIndex(e => e.id === resource.id);
    allResources[oldResourceIndex] = resource;
    this.setResources(allResources);
  }

  @action
  saveResource = resource => {
    const allResources = [...this.resources];
    allResources.push(resource);
    this.setResources(allResources);
  }

  getResourceById = id => {
    return this.resources.find(el => el.id === id);
  };

  @action
  handleUpdateResource = newResource => {
    let oldResource = this.getResourceById(newResource.id);
    _.assign(oldResource, newResource);
  };

  @action
  createResource = resource => {
    this.resources.unshift(resource);
  };

  @action
  deleteResource = id => {
    const allResources = [...this.resources];
    let index = _.findIndex(allResources, el => el.id === id);
    allResources.splice(index, 1);
    this.setResources(allResources);
  };

  @action
  sortResources = resources => {
    return resources.sort((resource_a, resource_b) => resource_a.title.localeCompare(resource_b.title));
  }

  @action
  handleChange = data => {
    _.assign(this.resource, data);
  }
}

export default new ResourcesStore();



// WEBPACK FOOTER //
// ./src/stores/ResourcesStore.js